import React, { useRef } from 'react';
import styles from '../cartoesdecreditoaltarenda/cartoesdecreditoaltarenda.module.scss';
import Perfil from './src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import SiteIcon from '../../icons/siteIcon.tsx';
import TopLeftImage from './src/top-left.png';
import BottomLeftImage from './src/bottom-right.png';
import LinkPersonalizado6 from '../../components/LinkPersonalizado6/linkPersonalizado6.tsx';
import YoutubeIcon from '../../icons/youtubeIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';

const Cartoesdecreditoaltarenda: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);

    return (
        <div className={styles.cartoesdecreditoaltarenda}>

            <div className={styles["body-thunder"]}>
                <div className={styles["background-thunder"]}></div>
                <div className={styles["top-left-image-wrapper"]}>
                    <img
                        className={styles["top-left-image"]}
                        src={TopLeftImage}
                        alt="Top Left Image"
                    />
                </div>
                <div className={styles["bottom-right-image-wrapper"]}>
                    <img
                        className={styles["bottom-right-image"]}
                        src={BottomLeftImage}
                        alt="Bottom Right Image"
                    />
                </div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        ref={imgRef}
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1 className="mb-2 mt-4">CARTÕES DE CRÉDITO</h1>
                    <h1 className={`${styles["border-clean"]} pb-3 mb-3`}>ALTA RENDA</h1>
                    <div className={styles.links}>
                        <LinkPersonalizado6
                            href="https://youtube.com/@cartoesdecreditoaltarenda?si=usq8fxrZHlvpn1F9"
                            title="CARTÕES DE CRÉDITO"
                            icon={<YoutubeIcon height="30" color="#ffffff" />}
                            colorText="#24221f"
                        />
                        <LinkPersonalizado6
                            href="https://altarendablog.com.br/"
                            title="BLOG"
                            icon={<SiteIcon height="28" color="#ffffff" />}
                            colorText="#24221f"
                        />
                        <LinkPersonalizado6
                            href="https://www.instagram.com/cartoesdecreditoaltarenda?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="30" color="#ffffff" />}
                            colorText="#24221f"
                        />
                        <LinkPersonalizado6
                            href="https://youtube.com/@altarendaretro?si=4U7Largz_eftcie_"
                            title="ALTA RENDA RETRO"
                            icon={<YoutubeIcon height="30" color="#ffffff" />}
                            colorText="#24221f"
                        />
                        <LinkPersonalizado6
                            href="https://wa.me/5516981019581?text=Olá, gostaria de mais informações sobre parcerias."
                            title="CONTATO PARCERIAS"
                            icon={<WhatsappIcon height="36" color="#ffffff" />}
                            colorText="#24221f"
                        />
                        <LinkPersonalizado6
                            href="https://www.tiktok.com/@altarendacartoes?_t=ZM-8ugHJbwjMSD&_r=1"
                            title="TIKTOK"
                            icon={<TiktokIcon height="28" color="#ffffff" />}
                            colorText="#24221f"
                        />
                        <LinkPersonalizado6
                            href="https://altarendablog.com.br/2022/11/03/exclusivo-melhores-links-e-indicacoes-do-alta-renda-blog/"
                            title="INDICAÇÃO LINKS CARTÕES"
                            icon={<SiteIcon height="28" color="#ffffff" />}
                            colorText="#24221f"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cartoesdecreditoaltarenda;
